import type { FaireProductEntity } from "../../entity_types/product";

export const p_6yvyd9v679: FaireProductEntity = {
  token: "p_6yvyd9v679",
  type: "product",
  name: "HEALTHY SCALP MICROBIOME Natural Shampoo Without Lye - 240ML",
  brandToken: "b_eznxtx44ut",
  brandName: "The Sacred Essence",
  imageUrl:
    "https://cdn.faire.com/fastly/2bff382138354b0b94afea9842c11008c4216e4ee9c6cd59f54481924753a617.png",
  galleryImageUrls: [],
  priceDollars: 32.22,
  description:
    "HEALTHY SCALP MICROBIOME SHAMPOO WITH CANANGA + VANILLA + BASIL is a 100% natural, gentle coconut-based shampoo with potent plant medicines to clean, clear, purify, strengthen, and nourish hair and scalp. It is antifungal, antidandruff, non-clogging, and deeply moisturizing. It restores a healthy scalp microbiome, leaving scalp and hair healthy and strong. Cananga is both uplifting and calming; it balances and regulates oil production in the scalp and hair while soothing inflammation and irritation. It enhances blood circulation, encourages the growth of new and stronger hair, hydrates, conditions, heals dandruff, and prevents infections. \n\nHealthy Scalp Microbiome, all-natural, plant-based, concentrated Shampoo is made without lye; it contains high-quality organic essential oils and food-grade organic ingredients, leaving the scalp visibly healthier, and hair stronger and fuller after one application. \n\nSize: 240ML in a glass bottle\nScent: Warm, floral with Vanilla and fresh Basil\n",
  tags: [],
  msrpDollars: 64.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:32.668Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
